"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ContentWithHeaderLayoutTemplate = _interopRequireDefault(require("../../../common/LayoutTemplates/ContentWithHeaderLayoutTemplate/ContentWithHeaderLayoutTemplate"));
var _RegionSettingsContainer = _interopRequireDefault(require("./RegionSettings/RegionSettingsContainer"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var profileAndSecurityWidgetClasses = (0, _cssClassesHelper.getBEMClasses)(['profile-and-security-widget']);
var RegionSettingsCardComponent = function RegionSettingsCardComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  var getLayoutHeader = function getLayoutHeader(header, classes) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes('header')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes('header-text')
    }, header));
  };
  return /*#__PURE__*/_react["default"].createElement(_ContentWithHeaderLayoutTemplate["default"], {
    header: getLayoutHeader(t("Region"), profileAndSecurityWidgetClasses),
    customClass: "profile-and-security-widget"
  }, /*#__PURE__*/_react["default"].createElement(_RegionSettingsContainer["default"], null));
};
var _default = exports["default"] = RegionSettingsCardComponent;